
export default ({ Factory }) => ({

  /**
   * Отправка письма
   * @param {String} type - тип письма 
   * @param {Object} source - данные
   */
  send: (type, source) => Factory[type].post(source)
})